<template>
    <modal :adaptive="true" height="auto" name="create-sub-user">
    <d-row>
        <d-col lg="12">
            <d-card class="card-small card-post">
                <d-card-body>
                    <h6>Add new sub user</h6>
                    <d-row class="d-flex justify-content-center">
                        <d-col lg="12">
                            <d-form id="usersForm" @submit.prevent="createNewSubUser(newUserData)">
                                <d-form-row class="mt-3">
                                    <d-col
                                        class="form-group"
                                        md="12"
                                    >
                                        <label for="email">
                                            Email
                                        </label>
                                        <d-form-input
                                            v-model="newUserData.email"
                                            type="email"
                                            id="email"
                                            placeholder="Enter user email"
                                            required
                                        />
                                    </d-col>

                                    <d-col
                                        class="form-group"
                                        md="12"
                                    >
                                        <label for="firstName">
                                            First name
                                        </label>
                                        <d-form-input
                                            v-model="newUserData.firstName"
                                            type="text"
                                            id="firstName"
                                            placeholder="Enter user first name"
                                            required
                                        />
                                    </d-col>

                                    <d-col
                                        class="form-group"
                                        md="12"
                                    >
                                        <label for="lastName">
                                            Last name
                                        </label>
                                        <d-form-input
                                            v-model="newUserData.lastName"
                                            type="text"
                                            id="lastName"
                                            placeholder="Enter user last name"
                                            required
                                        />
                                    </d-col>

                                    <d-col
                                        class="form-group"
                                        md="6"
                                    >
                                        <label for="password">
                                            Password
                                        </label>
                                        <d-form-input
                                            v-model="newUserData.password"
                                            type="password"
                                            id="password"
                                            minlength="6"
                                            placeholder="Create new password"
                                            required
                                        />
                                    </d-col>

                                    <d-col
                                        class="form-group"
                                        md="6"
                                    >
                                        <label for="confirmPassword">
                                            Confirm password
                                        </label>
                                        <d-form-input
                                            v-model="confirmPassword"
                                            type="password"
                                            id="confirmPassword"
                                            minlength="6"
                                            placeholder="Enter password once again"
                                            required
                                        />
                                    </d-col>

                                    <d-col
                                        class="form-group"
                                        md="12"
                                    >
                                        <label for="phone">
                                            Phone
                                        </label>
                                        <d-form-input
                                            v-model="newUserData.phone"
                                            type="tel"
                                            id="phone"
                                            placeholder="Enter user number"
                                            required
                                        />
                                    </d-col>

                                    <d-col
                                        class="form-group"
                                        md="12"
                                    >
                                        <label>
                                            Role
                                        </label>
                                        <d-form-select
                                            required
                                            v-model="newUserData.role"
                                            @change="handleRoleChanged"
                                        >
                                            <option v-for="role in acceptableRoles" :value="role.slug">{{ role.name }}</option>
                                        </d-form-select>
                                    </d-col>

                                    <d-col v-if="['regular-user', 'experienced-user'].includes(newUserData.role)" class="form-group" md="12">
                                        <label>Viewing domains</label>
                                        <b-form-select
                                            multiple
                                            :select-size="3"
                                            v-model="websites"
                                        >
                                            <option
                                                v-for="item in userInfo.websites"
                                                :key="item.id"
                                                :value="item.id"
                                            >
                                                {{ item.domain }}
                                            </option>
                                        </b-form-select>
                                    </d-col>

                                    <d-col md="12" class="form-group d-flex justify-content-end">
                                        <button type="button" @click="hideModal" class="btn btn-secondary mr-3">Cancel</button>
                                        <input value="Done" type="submit" class="btn btn-success">
                                    </d-col>
                                </d-form-row>
                            </d-form>
                        </d-col>
                    </d-row>
                </d-card-body>
            </d-card>
        </d-col>
    </d-row>
</modal>
</template>
<script>
  import notification from '@/mixins/notification';
  import permissions from '../../mixins/permissions';
  import { SubUsersService, ErrorService } from '@/main';

  export default {
    props: ['roles', 'permissions'],
    name: "CreateSubUserModal",
    mixins: [notification, permissions],

    data() {
      return {
        confirmPassword: '',
        websites: [],
        newUserData: {
          email: '',
          firstName: '',
          lastName: '',
          password: '',
          phone: '',
          role: ''
        },
      };
    },
    computed: {
      userInfo () {
        return this.$store.getters.userInfo
      },
      acceptableRoles() {
        return this.roles.filter(r => r.name !== 'Super Admin')
      }
    },
    methods: {
      validateForm() {
        if (this.confirmPassword !== this.newUserData.password) {
          this.confirmPassword = ''
          this.newUserData.password = ''
          this.showNotification('error-notification', 'Wrong password confirmation', "Password confirmation doesn't match the password. Try again")
          return false
        }

        if (this.newUserData.password.length < 6) {
          this.confirmPassword = ''
          this.newUserData.password = ''
          this.showNotification('error-notification', 'Wrong password', "Password should contain more than 6 symbols")
          return false
        }

        const regExperssion = /^(0|[0-9]\d*)$/
        const regValue = regExperssion.exec(this.newUserData.phone)
        if (!regValue) {
          this.showNotification('error-notification', 'Wrong phone number', "Phone number should contain only numbers")
          return false
        }
        return true
      },

      trimValues() {
        this.newUserData.email = this.newUserData.email.trim()
        this.newUserData.firstName = this.newUserData.firstName.trim()
        this.newUserData.lastName = this.newUserData.lastName.trim()
        this.newUserData.phone = this.newUserData.phone.trim()
      },

      mapPermissions() {
        if (['regular-user', 'experienced-user'].includes(this.newUserData.role)) {
          const slug = this.newUserData.role === 'experienced-user' ? this.permissionTypes.websiteWriteSpecific : this.permissionTypes.websiteReadSpecific
          const permissionId = this.permissions.find(p => p.slug === slug).id

          return this.websites.map(websiteId => {
            return {
              permission_id: permissionId,
              permissionable_id: websiteId,
              permissionable_type: 'website'
            }
          })
        }

        return []
      },

      async createNewSubUser(user) {
        if (!this.validateForm()) {
          return
        }
        try {
          this.trimValues()
          user.specific_permissions = this.mapPermissions()
          await SubUsersService.addSubUser(user)
          this.showNotification('success', '', 'User successfully added !')
          this.hideModal()
          this.resetNewUserData()
          this.$router.push('/dashboard')
          this.$router.go()
        } catch(e) {
          this.showNotification('error-notification', ErrorService.getErrorMessage(e.networkError.result.errors[0]))
        }
      },

      resetNewUserData() {
        this.confirmPassword = ''
        Object.keys(this.newUserData).map(el => this.newUserData[el] = '')
      },

      handleRoleChanged(role) {
        if (['regular-user', 'experienced-user'].includes(role)) {
          this.websites = []
        }
      },

      hideModal() {
        this.$modal.hide('create-sub-user');
      },
    }
  };
</script>
